import { render, staticRenderFns } from "./Mechanism.vue?vue&type=template&id=554fa86b&scoped=true"
import script from "./Mechanism.vue?vue&type=script&lang=js"
export * from "./Mechanism.vue?vue&type=script&lang=js"
import style0 from "./Mechanism.vue?vue&type=style&index=0&id=554fa86b&prod&lang=less&scoped=true"
import style1 from "./Mechanism.vue?vue&type=style&index=1&id=554fa86b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554fa86b",
  null
  
)

export default component.exports